import React from "react";
import { motion } from "framer-motion";
import { HardHat, GraduationCap, Building, Activity, Calendar, MapPin } from "lucide-react";
import { Badge } from "react-bootstrap";

const ProjectsSection = ({ data }) => {
    const getIcon = (type) => {
        switch (type.toLowerCase()) {
            case 'infrastructure': return <Activity size={18} />;
            case 'industrial': return <Building size={18} />;
            case 'healthcare': return <GraduationCap size={18} />;
            default: return <HardHat size={18} />;
        }
    };

    const getStatusColor = (status) => {
        if (status.toLowerCase().includes('under construction')) return 'success';
        if (status.toLowerCase().includes('expansion')) return 'primary';
        if (status.toLowerCase().includes('design')) return 'warning';
        return 'secondary';
    };

    return (
        <div className="mt-8">
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-yellow-50 rounded-lg text-yellow-600">
                    <HardHat size={20} />
                </div>
                <h2 className="text-xl font-bold text-gray-800 m-0">Major Active Projects</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {data.map((project, i) => (
                    <motion.div
                        key={i}
                        whileHover={{ y: -5 }}
                        className="bg-white shadow-sm rounded-3xl p-5 border border-gray-100 flex flex-col transition-all"
                    >
                        <div className="d-flex justify-content-between align-items-start mb-3">
                            <div className="p-2 bg-gray-50 rounded-lg text-gray-400">
                                {getIcon(project.type)}
                            </div>
                            <Badge bg={getStatusColor(project.status)} className="px-2 py-1 rounded-pill fw-medium" style={{ fontSize: '0.65rem' }}>
                                {project.status}
                            </Badge>
                        </div>

                        <h3 className="font-bold text-gray-900 mb-1 leading-tight">{project.project}</h3>
                        <p className="text-xs text-gray-400 mb-3 d-flex align-items-center gap-1">
                            <MapPin size={12} /> {project.county} County
                        </p>

                        <div className="mt-auto pt-4 border-t border-gray-50 d-flex justify-content-between align-items-center">
                            <div className="text-sm font-bold text-red-600 bg-red-50 px-2 py-1 rounded">
                                {project.value}
                            </div>
                            <div className="text-xs text-gray-400 d-flex align-items-center gap-1">
                                <Calendar size={12} /> {project.completion}
                            </div>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default ProjectsSection;